import React, { useEffect, useState } from 'react';
// import React, { useRef } from "react";
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import AnimatedComponent from "../Components/AnimatedComponent";
import { fadeInY, popOut, stagger } from "../utils/animatedVariants";
// import Counter from '../Components/CounterNumber'
import HomeSlider from '../Components/Slider'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Images

import Gflage from "../assets/images/flage/Flag_of_Guinea.png"
import Eflage from "../assets/images/flage/us-flag.png"

// Banner image

import bgshape from "../assets/images/layout/bgstrip.png"
import bgstripbot from '../assets/images/layout/bgstrip-bot.png'
// import bg005 from '../assets/images/layout/EE8DQJJ-min.png'
import YE2ARQM from '../assets/images/layout/YE2ARQM-min.png'
import HEC7BTZ from '../assets/images/layout/HEC7BTZ-min.png'
import T52GYVU from '../assets/images/layout/T52GYVU-1-min.png'

// Avtar Images

import avtar01 from '../assets/images/avatars/avatar1.png'
import avtar02 from '../assets/images/avatars/avatar9.png'


// client logo image
import partner1 from "../assets/images/products/partner-1.png"
import partner2 from "../assets/images/products/partner-2.png"
import partner3 from "../assets/images/products/partner-3.png"
import partner4 from "../assets/images/products/partner-4.png"
// import partner5 from "../assets/images/products/partner-5.png"
// import partner6 from "../assets/images/products/partner-6.png"

// Icons
import { IoIosArrowForward } from "react-icons/io";

import { FaQuoteRight, FaStar } from "react-icons/fa";
import { GoPlay } from "react-icons/go";

import { FiCheckSquare } from "react-icons/fi";



import invoice from "../assets/images/icons/invoice.png"
import seller from "../assets/images/icons/seller.png"
import paymentrequest from "../assets/images/icons/payment-request.png"
import bankaccount from "../assets/images/icons/bank-account.png"
import cardicon from "../assets/images/icons/icon-7.png"
import cardicon2 from "../assets/images/icons/icon-8.png"
import slide004 from '../assets/images/layout/slide004.jpg'
import bill from "../assets/images/icons/invoice.png"
import clickonly from "../assets/images/icons/merchants.png"
import sendmony from "../assets/images/icons/transection.png"
import walletmoney from "../assets/images/icons/earning.png"
import sendmoney from "../assets/images/icons/mobilemoney.png"

import step01 from "../assets/images/icons/step01.png"
import step02 from "../assets/images/icons/step02.png"
import step03 from "../assets/images/icons/step03.png"
import step04 from "../assets/images/icons/step04.png"
import security from "../assets/images/icons/security.png"
import customer from "../assets/images/icons/customer.png"
import pay from "../assets/images/icons/pay.png"

import app01 from "../assets/images/icons/app_btn1.png"
import app02 from "../assets/images/icons/app_btn2.png"
import iphoneslider from "../assets/images/layout/iphone-slider.png"



// Side images
import side011 from "../assets/images/layout/side0111.png"
import PHRFBYBmin from "../assets/images/layout/PHRFBYB-min.png"
import PHRFBYB2 from "../assets/images/layout/PHRFBYB-2.png"
import side003 from "../assets/images/layout/side003.png"


// Blog Images

import blog01 from '../assets/images/blog/post-6-min.png'
import blog02 from '../assets/images/blog/post-blog-02.png'
import blog03 from '../assets/images/blog/post-blog-03.png'

// Video player
import ReactPlayer from "react-player";


const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4,
        slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
        breakpoint: { max: 1024, min: 768 },
        items: 3,
        slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 767, min: 464 },
        items: 3,
        slidesToSlide: 1 // optional, default to 1.
    }
};
const sliderImageUrl = [
    //First image url
    {
        url:
            partner1
    },
    //Second image url
    {
        url:
            partner2
    },
    //Third image url
    {
        url:
            partner3
    },
    //Fourth image url
    {
        url:
            partner4
    },

    //     //Five image url

    //     // {
    //     //   url:
    //     //     partner5
    //     // },

    //     //Six image url

    //     // {
    //     //   url:
    //     //     partner6
    //     // }

    // 


];


function Home() {



    const { t } = useTranslation();

    const [isActive, setIsActive] = useState(false);
    const [selectedOption, setSelectedOption] = useState('English'); // Default selected option
    const [logocountry, setlogocountry] = useState(Gflage); // Default selected option

    useEffect(() => {
        if (selectedOption === "Français") {
            setlogocountry(Gflage)
        } else {
            setlogocountry(Eflage)
        }
    }, [selectedOption])

    const handleOptionClick = (language, countryFlag) => {
        setSelectedOption(language); // Update the selected option
        setlogocountry(countryFlag); // Change the flag image
        i18next.changeLanguage(language === 'Français' ? 'guinea' : 'english'); // Change the i18next language
        setIsActive(false); // Close the dropdown
    };


    return (
        <div>

            <section className={'h-full bg-cover relative'}>
                < HomeSlider />
            </section>

            {/*Client Section */}
            <div className={'w-full 3xl:px-32 2xl:px-32 lg:px-16 px-6 relative'}>

                <AnimatedComponent
                    tag="div"
                    variants={fadeInY(0.8)}
                    // variants={stagger("negative")}
                    className={''}>
                    {/* Multi imagesg carousel */}
                    <div className={'bg-white shadow-lg  rounded-md px-6 py-4  mt-[-88px] md-max:mt-0 md-max:px-3 relative'}>
                        <div className='catousel-tex inline-flex md-max:inline items-center lg:gap-16 !gap-0'>
                            <div className={'w-20p md-max:w-0  text-[17px] font-semibold text-[#0b1622] text-left md-max:hidden'}>{t('main.client_logo.Trusted_by')} </div>
                            <div className={'grid w-80p  md-max:!w-full lg-max:w-90p'}>
                                <Carousel
                                    additionalTransfrom={0}
                                    arrows
                                    autoPlay={true}
                                    autoPlaySpeed={3000}
                                    centerMode={false}
                                    className=""
                                    containerclassName="container-with-dots"
                                    dotListclassName=""
                                    draggable
                                    focusOnSelect={false}
                                    infinite
                                    itemclassName=""
                                    keyBoardControl
                                    minimumTouchDrag={80}
                                    renderButtonGroupOutside={false}
                                    renderDotsOutside={false}
                                    responsive={{
                                        desktop: {
                                            breakpoint: {
                                                max: 3000,
                                                min: 1024
                                            },
                                            items: 4,
                                            partialVisibilityGutter: 50
                                        },
                                        mobile: {
                                            breakpoint: {
                                                max: 464,
                                                min: 0
                                            },
                                            items: 2,
                                            partialVisibilityGutter: 30
                                        },
                                        tablet: {
                                            breakpoint: {
                                                max: 1024,
                                                min: 464
                                            },
                                            items: 3,
                                            partialVisibilityGutter: 30
                                        }
                                    }}
                                    showDots={false}
                                    sliderclassName=""
                                    slidesToSlide={1}
                                    swipeable
                                >
                                    <div className='carousel-item-padding-40-px md:py-7 py-4 px-7' ><img className='' src={partner1} alt="partner1" /></div>
                                    <div className='carousel-item-padding-40-px md:py-7 py-4 px-7'><img className=' ' src={partner2} alt="partner2" /></div>
                                    <div className='carousel-item-padding-40-px md:py-7 py-4 px-7' ><img className='' src={partner3} alt="partner3" /></div>
                                    <div className='carousel-item-padding-40-px md:py-7 py-4 px-7'><img className='' src={partner4} alt="partner4" /></div>
                                </Carousel>
                            </div>
                        </div>
                    </div>
                </AnimatedComponent>

            </div>






            {/* About Section */}

            <div className={'w-full pt-20 pb-10 3xl:px-32 2xl:px-32 lg:px-16 xl-max:py-6  px-6'}>
                <div className={'items-start  h-full grid grid-cols-1 xl:grid-cols-2  xl:gap-16 xl-max:pt-0'}>
                    <div className={'xl-max:order-last'}>
                        <AnimatedComponent
                            tag="div"
                            variants={stagger("negative")}
                            className={'leading-loose text-left'}>
                            {/* <span className="small-head uppercase motion-safe:animate-bounce">About Us</span> */}
                            <AnimatedComponent tag="div" variants={fadeInY(0.8)} className="">
                                <h2 className="Heading-02 mb-6  group-hover:animate-bounce relative xl-max:w-88p xl-max:mt-5">{t("main.About_Us.about-head")}
                                    <div id="flip" className={'inline-block'}>
                                        <div><div className={'simple'}>{t("main.About_Us.flip_01")}</div></div>
                                        <div><div className={'Secure'}>{t("main.About_Us.flip_02")}</div></div>
                                        <div><div className={'Reliable'}>{t("main.About_Us.flip_03")}</div></div>
                                    </div>
                                </h2>

                            </AnimatedComponent>
                            <AnimatedComponent tag="div" variants={fadeInY(0.8)} className="">
                                {/* <h5 className="sub-titles my-4">Making your payment experience Simple Secure and Reliable</h5> */}
                                <p className={'paragraph'}>{t("main.About_Us.about_para")}</p>




                            </AnimatedComponent>
                        </AnimatedComponent>
                    </div>
                    <div className=" ">
                        <AnimatedComponent
                            tag="img"
                            variants={popOut}
                            src={side011}
                            alt=""
                            className={'rounded-[5px]'}
                        />
                    </div>


                </div>
            </div>

            {/* Payment Section */}

            <div className={'w-full py-20 xl-max:pt-0 xl-max:pb-6 3xl:px-32 2xl:px-32 lg:px-16 px-6'}>
                <div className={'items-start  h-full grid grid-cols-1 3xl:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2  xl:gap-16 xl-max:pt-0'}>
                    <div className={'xl-max:order-last xl-max:mt-8'}>
                        <AnimatedComponent
                            tag="img"
                            variants={popOut}
                            src={PHRFBYBmin}
                            alt=""
                            className={'rounded-sm mb-6 lg-max:hidden'}
                        />
                        <AnimatedComponent
                            tag="img"
                            variants={popOut}
                            src={PHRFBYB2}
                            alt=''
                            className={'rounded-sm'}
                        />
                    </div>

                    <div className={''}>
                        <AnimatedComponent
                            tag="div"
                            variants={stagger("negative")}
                            className={'leading-loose text-left'}>
                            {/* <span className="small-head uppercase">Online Payment</span> */}
                            <AnimatedComponent tag="div" variants={fadeInY(0.8)} className="">
                                <h2 className="Heading-02 mb-6">{t("main.online_pay.Main_head")} <strong> {t("main.online_pay.main_head_strong")} </strong></h2>
                                <p className={'paragraph'}> {t("main.online_pay.paragraph")}</p>

                                <div className={'w-full mt-8'}>
                                    {/* Block 01 */}
                                    <div className={'blocks mt-3'}>
                                        <ul className={'elementor-icon-list-items flex  items-start gap-3'}>
                                            <li className={'flex !font-semibold !text-[#75a743] !text-[22px] items-center mt-2'}>
                                                <span className={'mr-2 font-bold border-[2px] border-[#d3be48] rounded-full  w-[65px] h-[65px] flex justify-center items-center'}>
                                                    <img src={sendmony} alt='icon' className={'w-9 '} />
                                                </span>
                                                {/* <FaMoneyBillTransfer className='mr-2 font-bold border-[2px] border-[#75a743] rounded-full p-2 w-12 h-12' /> */}

                                            </li>
                                            <span>
                                                <h3 className={'elementor-icon-list-text text-[#75a743]'}>{t("main.online_pay.point_01.Sub_head_01")}</h3>
                                                <p className={'paragraph'}>{t("main.online_pay.point_01.Sub_head_para")}</p>
                                            </span>
                                        </ul>

                                    </div>

                                    {/* Block 02 */}
                                    <div className={'blocks mt-3'}>
                                        <ul className={'elementor-icon-list-items  flex  items-start gap-3'}>
                                            <li className={'flex !font-semibold !text-[#75a743] !text-[22px] items-center mt-2'}>
                                                <span className={'mr-2 font-bold border-[2px] border-[#d3be48] rounded-full  w-[65px] h-[65px] flex justify-center items-center'}>
                                                    <img src={clickonly} alt={'icon'} className={'w-9 '} />
                                                </span>
                                                {/* <GiClick className='mr-2 font-bold  border-[2px] border-[#75a743] rounded-full p-2 w-12 h-12' /> */}

                                            </li>
                                            <span>
                                                <h3 className={'elementor-icon-list-text text-[#75a743]'}>{t("main.online_pay.point_02.Sub_head_02")}</h3>
                                                <p className={'paragraph'}>{t("main.online_pay.point_02.Sub_head_para")}</p>
                                            </span>
                                        </ul>

                                    </div>

                                    {/* Block 03 */}
                                    <div className={'blocks mt-3'}>
                                        <ul className={'elementor-icon-list-items  flex  items-start gap-3'}>
                                            <li className={'flex !font-semibold !text-[#75a743] !text-[22px] items-center mt-2'}>
                                                <span className={'mr-2 font-bold border-[2px] border-[#e4b945] rounded-full w-[65px] h-[65px] flex justify-center items-center'}>
                                                    <img src={bill} alt='icon' className={'w-9  '} />
                                                </span>

                                                {/* <HiMiniDocumentText className='mr-2 font-bold border-[2px] border-[#75a743] rounded-full p-2 w-12 h-12' /> */}

                                            </li>
                                            <span>
                                                <h3 className={'elementor-icon-list-text text-[#75a743]'}>{t("main.online_pay.point_03.Sub_head_03")}</h3>
                                                <p className={'paragraph'}>{t("main.online_pay.point_03.Sub_head_para")}</p>
                                            </span>
                                        </ul>

                                    </div>

                                    {/* Button Area */}
                                    <div className={'b mt-10 relative h-14 w-64  flex justify-center lg-max:w-full  items-center'}>
                                        <div className={'i h-14 w-64 bg-gradient-to-br from-[#fe7b05] to-[#eabb76] items-center rounded-sm shadow-2xl cursor-pointer absolute overflow-hidden transform hover:scale-x-110 hover:scale-y-105 transition duration-300 ease-out'}>
                                        </div>
                                        <Link className={'text-start text-white font-medium flex items-center z-10 pointer-events-none'}>{t("main.online_pay.Get_started_now")} <IoIosArrowForward className={'ml-2'} /></Link>

                                    </div>

                                </div>

                            </AnimatedComponent>
                        </AnimatedComponent>
                    </div>


                </div>
            </div>

            {/* Features Section */}

            <div className={'w-full 3xl:px-32 2xl:px-32 lg:px-16 px-6 pb-32 bg-[#fafafa] py-20 xl-max:pt-0 xl-max:pb-6 '}>
                <div className={'items-center  h-full grid grid-cols-1 gap-16 '}>

                    <div className={'w-full'}>
                        <AnimatedComponent
                            tag="div"
                            variants={stagger("negative")}
                            className={'leading-loose text-center'}>
                            {/* <span className="small-head uppercase">Features</span> */}
                            <AnimatedComponent tag="div" variants={fadeInY(0.8)} className="">
                                <h2 className="Heading-02 my-6 w-65p mx-auto  xl-max:mt-0 md-max:w-full">{t("main.powerful_reasons.main_head")} <strong> {t("main.powerful_reasons.strong_head")} </strong> </h2>
                                <p className={'paragraph m-auto lg:max-w-2xl md:max-w-xl'}>{t("main.powerful_reasons.paragraph")}</p>

                            </AnimatedComponent>
                        </AnimatedComponent>

                        {/* Feature Card*/}
                        <AnimatedComponent
                            tag="div"
                            variants={stagger("negative")}
                            className={'leading-loose m-auto xl-max:px-0 text-center'}>

                            <AnimatedComponent tag="div" variants={fadeInY(0.8)} className={'text-center'}>

                                <div className={'text-center mx-auto grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 justify-items-center justify-center gap-10  mt-10'}>

                                    {/* Feature Box*/}
                                    <div className={'px-8 py-10 flex justify-center mx-auto w-full bg-white shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl'}>
                                        <div>
                                            <img className={'mx-auto mb-4 w-[80px]'} src={sendmoney} alt='feature' />
                                            <div className={'py-3'}>
                                                <h6 className={'fearure-head'}>{t("main.powerful_reasons.Features.Feature_Head_01")}</h6>
                                                <p className={'feature-para'}>{t("main.powerful_reasons.Features.feature_para_01")}</p>
                                                {/* Button Area */}
                                                {/* <div className="b mt-6 relative h-14 w-14 mx-auto flex justify-center items-center">
                                                    <div className="i h-12 w-12 bg-gradient-to-br from-[#fe7b05] to-[#eabb76] items-center rounded-sm shadow-2xl cursor-pointer absolute overflow-hidden transform hover:scale-x-110 hover:scale-y-105 transition duration-300 ease-out">
                                                    </div>
                                                    <Link className="text-center text-white font-medium flex items-center z-10 pointer-events-none"> <IoIosArrowForward className='' /></Link>

                                                </div> */}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Feature Box*/}
                                    <div className={'px-8 py-10 flex justify-center mx-auto w-full bg-white shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl'}>
                                        <div>
                                            <img className={'mx-auto mb-4 w-[70px]'} src={paymentrequest} alt='feature' />
                                            <div className={'py-3'}>
                                                <h6 className={'fearure-head'}>{t("main.powerful_reasons.Features.Feature_Head_02")}</h6>
                                                <p className={'feature-para'}>{t("main.powerful_reasons.Features.feature_para_02")}</p>
                                                {/* Button Area */}
                                                {/* <div className="b mt-6 relative h-14 w-14 mx-auto flex justify-center items-center">
                                                    <div className="i h-12 w-12 bg-gradient-to-br from-[#fe7b05] to-[#eabb76] items-center rounded-sm shadow-2xl cursor-pointer absolute overflow-hidden transform hover:scale-x-110 hover:scale-y-105 transition duration-300 ease-out">
                                                    </div>
                                                    <Link className="text-center text-white font-medium flex items-center z-10 pointer-events-none"> <IoIosArrowForward className='' /></Link>

                                                </div> */}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Feature Box*/}
                                    <div className={'px-8 py-10 flex justify-center mx-auto w-full bg-white shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl'}>
                                        <div>
                                            <img className={'mx-auto mb-4 w-[70px]'} src={invoice} alt='feature' />
                                            <div className={'py-3'}>
                                                <h6 className={'fearure-head'}>{t("main.powerful_reasons.Features.Feature_Head_03")}</h6>
                                                <p className={'feature-para'}>{t("main.powerful_reasons.Features.feature_para_03")}</p>
                                                {/* Button Area */}
                                                {/* <div className="b mt-6 relative h-14 w-14 mx-auto flex justify-center items-center">
                                                    <div className="i h-12 w-12 bg-gradient-to-br from-[#fe7b05] to-[#eabb76] items-center rounded-sm shadow-2xl cursor-pointer absolute overflow-hidden transform hover:scale-x-110 hover:scale-y-105 transition duration-300 ease-out">
                                                    </div>
                                                    <Link className="text-center text-white font-medium flex items-center z-10 pointer-events-none"> <IoIosArrowForward className='' /></Link>

                                                </div> */}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Feature Box*/}
                                    <div className={'px-8 py-10 flex justify-center mx-auto w-full bg-white shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl'}>
                                        <div>
                                            <img className={'mx-auto mb-4 w-[70px]'} src={walletmoney} alt='feature' />
                                            <div className={'py-3'}>
                                                <h6 className={'fearure-head'}>{t("main.powerful_reasons.Features.Feature_Head_04")}</h6>
                                                <p className={'feature-para'}>{t("main.powerful_reasons.Features.feature_para_04")}</p>
                                                {/* Button Area */}
                                                {/* <div className="b mt-6 relative h-14 w-14 mx-auto flex justify-center items-center">
                                                    <div className="i h-12 w-12 bg-gradient-to-br from-[#fe7b05] to-[#eabb76] items-center rounded-sm shadow-2xl cursor-pointer absolute overflow-hidden transform hover:scale-x-110 hover:scale-y-105 transition duration-300 ease-out">
                                                    </div>
                                                    <Link className="text-center text-white font-medium flex items-center z-10 pointer-events-none"> <IoIosArrowForward className='' /></Link>

                                                </div> */}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Feature Box*/}
                                    <div className={'px-8 py-10 flex justify-center mx-auto w-full bg-white shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl'}>
                                        <div>
                                            <img className={'mx-auto mb-4 w-[70px]'} src={seller} alt='feature' />
                                            <div className={'py-3'}>
                                                <h6 className={'fearure-head'}>{t("main.powerful_reasons.Features.Feature_Head_05")}</h6>
                                                <p className={'feature-para'}>{t("main.powerful_reasons.Features.feature_para_05")}</p>
                                                {/* Button Area */}
                                                {/* <div className="b mt-6 relative h-14 w-14 mx-auto flex justify-center items-center">
                                                    <div className="i h-12 w-12 bg-gradient-to-br from-[#fe7b05] to-[#eabb76] items-center rounded-sm shadow-2xl cursor-pointer absolute overflow-hidden transform hover:scale-x-110 hover:scale-y-105 transition duration-300 ease-out">
                                                    </div>
                                                    <Link className="text-center text-white font-medium flex items-center z-10 pointer-events-none"> <IoIosArrowForward className='' /></Link>

                                                </div> */}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Feature Box*/}
                                    <div className={'px-8 py-10 flex justify-center mx-auto w-full bg-white shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl'}>
                                        <div>
                                            <img className={'mx-auto mb-4 w-[70px]'} src={bankaccount} alt='feature' />
                                            <div className={'py-3'}>
                                                <h6 className={'fearure-head'}>{t("main.powerful_reasons.Features.Feature_Head_06")}</h6>
                                                <p className={'feature-para'}>{t("main.powerful_reasons.Features.feature_para_06")}</p>
                                                {/* Button Area */}
                                                {/* <div className="b mt-6 relative h-14 w-14 mx-auto flex justify-center items-center">
                                                    <div className="i h-12 w-12 bg-gradient-to-br from-[#fe7b05] to-[#eabb76] items-center rounded-sm shadow-2xl cursor-pointer absolute overflow-hidden transform hover:scale-x-110 hover:scale-y-105 transition duration-300 ease-out">
                                                    </div>
                                                    <Link className="text-center text-white font-medium flex items-center z-10 pointer-events-none"> <IoIosArrowForward className='' /></Link>

                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AnimatedComponent>
                        </AnimatedComponent>


                    </div>


                </div>
            </div>

            {/* MERCHANT SERVICES Section */}


            <section className={'w-full  bg-[#0b1622] relative '}>
                <div className={'bg-cover  relative top-[-77px] left-0  bg-no-repeat'}>
                    <img className={'h-20'} src={bgshape} alt={'bgshape'} />
                </div>
                <div className={'w-full 3xl:px-32 2xl:px-32 lg:px-16 px-6'}>
                    <div className={'items-start  h-full grid grid-cols-1 xl:grid-cols-2  xl:gap-16 xl-max:pt-0'}>
                        <div className={'lg-max:order-last xl-max:mb-8'}>
                            <AnimatedComponent
                                tag="div"
                                variants={stagger("negative")}
                                className={'leading-loose text-left'}>
                                {/* <span className="small-head uppercase !bg-[#e7f1dd1a]">Merchat Services</span> */}
                                <AnimatedComponent tag="div" variants={fadeInY(0.8)} className="">
                                    <h2 className="Heading-02 my-6 !text-white">{t("main.About_Merchant.merchant_head")} <strong>{t("main.About_Merchant.strong_head")}</strong> </h2>
                                    {/* <h5 className="sub-titles my-4">Accept payments everywhere</h5> */}
                                    <p className={'paragraph !text-[#a0acbd]'}>
                                        {t("main.About_Merchant.merchant_para")}
                                    </p>

                                    <ul className={'elementor-icon-list-items mt-5'}>
                                        <li className={'elementor-icon-list-item'}>
                                            <span className={'elementor-icon-list-icon'}>
                                                <FiCheckSquare className={'text-[23px] text-[#75a743] mr-4'} />			</span>
                                            <span className={'elementor-icon-list-text !text-white'}>{t("main.About_Merchant.check_one")}
                                            </span>
                                        </li>
                                        <li className={'elementor-icon-list-item'}>
                                            <span className={'elementor-icon-list-icon'}>
                                                <FiCheckSquare className={'text-[23px] text-[#75a743] mr-4'} /> </span>
                                            <span className={'elementor-icon-list-text !text-white'}>{t("main.About_Merchant.check_two")}</span>
                                        </li>
                                        <li className={'elementor-icon-list-item'}>
                                            <span className={'elementor-icon-list-icon'}>
                                                <FiCheckSquare className={'text-[23px] text-[#75a743] mr-4'} />	</span>
                                            <span className={'elementor-icon-list-text !text-white'}>
                                                {t("main.About_Merchant.check_three")}
                                            </span>
                                        </li>
                                        <li className={'elementor-icon-list-item'}>
                                            <span className={'elementor-icon-list-icon'}>
                                                <FiCheckSquare className={'text-[23px] text-[#75a743] mr-4'} />	</span>
                                            <span className={'elementor-icon-list-text !text-white'}>
                                                {t("main.About_Merchant.check_four")}
                                            </span>
                                        </li>
                                    </ul>


                                    {/* Button Area */}
                                    <div className={'b mt-10 relative h-14 w-64 lg-max:w-full   flex justify-center items-center'}>
                                        <div className={'i h-14 w-64  bg-gradient-to-br from-[#fe7b05] to-[#eabb76] items-center rounded-sm shadow-2xl cursor-pointer absolute overflow-hidden transform hover:scale-x-110 hover:scale-y-105 transition duration-300 ease-out'}>
                                        </div>
                                        <Link className={'text-center text-white font-medium flex items-center z-10 pointer-events-none'}>{t("main.About_Merchant.Get_started_now")}<IoIosArrowForward className={'ml-2'} /></Link>


                                    </div>

                                </AnimatedComponent>
                            </AnimatedComponent>
                        </div>
                        <div className={'relative'}>
                            <AnimatedComponent
                                tag="img"
                                variants={popOut}
                                src={side003}
                                alt={''}
                                className={'rounded-[6px]  relative mx-auto'}
                            />

                            {/* BOX - 1 */}
                            <div className={'elementor-widget-wrap absolute bottom-48 -left-8 lg-max:-left-0 md-max:!bottom-36'}>
                                <div className={'elementor-column flex gap- p-5 lg-max:w-90p sm-max:!w-95p w-70p float-left text-left bg-[#ffffffc4] rounded-md'}>
                                    <div className={'elementor-widget-container'}>
                                        <img className={'w-[120px] mr-6'} src={cardicon} alt={'icon7'} />
                                    </div>
                                    <div className={'pl-5'} >
                                        <div className={'elementor-widget-container'}>
                                            <h6 className={'elementor-heading-title elementor-size-default'}>{t("main.About_Merchant.UPI")}</h6>
                                            <p className={'mt-2 text-[14px] md-max:text-[12px] sm-max:!text-[10px]'}>{t("main.About_Merchant.upi_para")}</p>
                                        </div>
                                    </div>


                                </div>
                            </div>
                            {/* BOX - 2 */}
                            <div className={'elementor-widget-wrap absolute bottom-8 -right-8 lg-max:right-0 md-max:bottom-4'}>
                                <div className={'elementor-column flex p-5 lg-max:w-90p w-70p float-right text-left bg-[#468d009c] rounded-md'}>
                                    <div className={'elementor-widget-container'}>
                                        <img className={'w-[60px] mr-6'} src={cardicon2} alt={'icon7'} />
                                    </div>
                                    <div className={'pl-5'}>
                                        <div className={'elementor-widget-container'}>
                                            <h6 className={'elementor-heading-title !text-white'}>
                                                {t("main.About_Merchant.Fraud_defenses")}
                                            </h6>
                                            <p className={'text-[#fff] mt-2  text-[14px] md-max:text-[12px] sm-max:!text-[10px]'}>
                                                {t("main.About_Merchant.fraud_para")}
                                            </p>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div className={'bg-cover  relative bottom-[-75px] left-0  bg-no-repeat'}>
                    <img className={'h-20'} src={bgstripbot} alt={'bgshape'} />
                </div>
            </section>


            {/* Step Section */}

            <div className={'w-full 3xl:px-32 2xl:px-32 lg:px-16 px-6  elementor-motion-effects-layer'}>
                <div className={'items-center  h-full grid grid-cols-1 gap-16 pt-28 xl-max:pb-[65px] pb-[420px]'}>

                    <div className={'w-full'}>
                        <AnimatedComponent
                            tag="div"
                            variants={stagger("negative")}
                            className={'leading-loosetext-center'}>
                            {/* <span className="small-head uppercase">Step</span> */}
                            <AnimatedComponent tag="div" variants={fadeInY(0.8)} className="">
                                <h2 className="Heading-02 xl-max:w-full  w-70p  !text-white font-bold mx-auto my-6">
                                    {t("main.step_section.Main_head")} <strong> {t("main.step_section.strong_head")} </strong> </h2>
                                <p className={'paragraph !text-white m-auto xl-max:w-full lg-max:!text-[12px]  w-60p'}>
                                    {t("main.step_section.paragraph")}
                                </p>

                            </AnimatedComponent>
                        </AnimatedComponent>

                        {/* Feature Card*/}
                        <AnimatedComponent
                            tag="div"
                            variants={stagger("negative")}
                            className={'leading-loose mx-auto px-28 xl-max:px-0 text-center relative'}>

                            <AnimatedComponent tag="div" variants={fadeInY(0.8)} className={'text-center mx-auto w-70p h-[480px] md-max:h-[320px] xl-max:w-95p xl-max:mt-10 xl:absolute left-0 right-0 top-5 z-5 rounded-[6px]'}>
                                <ReactPlayer
                                    url="https://vimeo.com/243556536"
                                    width={"100%"}
                                    height={"100%"}
                                    playing
                                    playIcon={<button><GoPlay /></button>}
                                    light={slide004}
                                    className={'rounded-[6px]'}
                                />
                            </AnimatedComponent>
                        </AnimatedComponent>

                    </div>
                </div>


            </div>

            {/* step grid*/}
            <div className={'w-full px-6 md:px-12 lg:px-18 2xl:px-32  pt-52 xl-max:pt-12 bg-[#fafafa]'}>
                <AnimatedComponent tag="div" variants={fadeInY(0.8)} className={'flex'}>
                    <div className={'grid grid-cols-4 xl-max:grid-cols-1 gap-8 xl-max:!gap-0'}>

                        <div className={'col-span-3 xl-max:col-span-full'}>

                            <div className={'text-left'} >

                                <h5 className={'misium-head'}>{t("main.step_section.step_service")}</h5>

                                <p className={'paragraph lg-max:!mt-5'}>{t("main.step_section.step_service_para")}</p>

                            </div>
                            <div className={'grid grid-cols-3  md-max:grid-cols-1   gap-8 lg-max:!gap-2  mt-4'}>



                                {/* step Box*/}
                                <div className={'p-8 flex mt-4 justify-between mx-auto w-full bg-white shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl'}>
                                    <div className={'py-3 text-left'}>
                                        <h6 className={'fearure-head'}><span><img className={'w-9 h-9'} src={step01} alt='srep' /></span>{t("main.step_section.Sign _up")} </h6>
                                        <p className={'feature-para !mt-2'}>{t("main.step_section.sign_para")}</p>
                                    </div>
                                </div>
                                {/* step Box*/}
                                <div className={'p-8 flex mt-4 justify-between mx-auto w-full bg-white shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl'}>
                                    <div className={'py-3 text-left'}>
                                        <h6 className={'fearure-head'}><span><img className={'w-10 h-10'} src={step02} alt='srep' /></span> {t("main.step_section.Verify_Your_Account")} </h6>
                                        <p className={'feature-para !mt-2'}>{t("main.step_section.account|_para")}</p>
                                    </div>
                                </div>
                                {/* step Box*/}
                                <div className={'p-8 flex mt-4 justify-between mx-auto w-full bg-white shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl'}>
                                    <div className={'py-3 text-left'}>
                                        <h6 className={'fearure-head'}><span><img className={'w-10 h-10'} src={step03} alt='srep' /></span> {t("main.step_section.Initiate_Transactions")} </h6>
                                        <p className={'feature-para !mt-2'}>{t("main.step_section.initiate_para")}</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'p-10 bg-[#0b1622] rounded-[6px] xl-max:!mt-5'}>
                            <div className={'py-3 text-left'}>
                                <h6 className={'fearure-head !text-white'}><span><img className={'w-10 h-10'} src={step04} alt='srep' /></span>{t("main.step_section.Explore_Features")} </h6>
                                <p className={'feature-para !mt-2 !text-white'}>{t("main.step_section.explore_para")}</p>
                            </div>
                            {/* Button Area */}
                            <div className={'b mt-2 relative h-12 w-full flex justify-center items-center'}>
                                <div className={'i h-12 w-full bg-gradient-to-br from-[#fe7b05] to-[#eabb76] items-center rounded-sm shadow-2xl cursor-pointer absolute overflow-hidden transform hover:scale-x-110 hover:scale-y-105 transition duration-300 ease-out'}>
                                </div>
                                <Link className={'relative text-center text-[14px] text-white font-medium flex items-center z-5 pointer-events-none'}>
                                    {t("main.step_section.Get_started_now")}  <IoIosArrowForward className={'ml-2'} /></Link>


                            </div>
                        </div>

                    </div>
                </AnimatedComponent>
            </div>

            {/* Number Counter */}
            {/* <div className='w-full lg:py-12 xl:py-16 py-20 md:px-12 lg:px-18 2xl:px-32 bg-[#fafafa]'>
        <div className='relative py-10 z-10 text-center  '>
          <span className="py-1 px-3 font-semibold text-[#0b1622] uppercase text-[18px] mb-3">Why choose us?</span>

        </div>
        <Counter />
      </div> */}

            {/* apply section */}


            <section className={'h-full w-full rounded-md'} >
                <div className={'w-full xl-max:py-6  pb-20 pt-40'}>
                    <AnimatedComponent
                        tag="div"
                        variants={stagger("negative")}
                        className={'leading-loose text-left'}>

                        <div className={'available-app-area'}>
                            <div className={'grid xl-max:grid-cols-1 grid-cols-2  justify-between gap-8  3xl:px-32 2xl:px-32 xl-max:px-5 sm-max:gap-1 px-6'}>


                                <div className={'app-caption text-left relative xl-max:w-60p'}>
                                    <div className={'section-tittle section-tittle3 '}>
                                        <h2> {t("main.Download_app.download_bct")}<br />
                                            <strong>  {t("main.Download_app.strong_head")}</strong></h2>
                                        <p className={' text-[#cdcdcd] text-[15px] md-max:text-[13px]  sm-max:text-[10px]'}>
                                            {t("main.Download_app.paragraph")}
                                        </p>
                                        <div className={'app-btn flex items-center gap-5 mt-5'}>
                                            <Link to={"#"} className={'w-52'}><img src={app01} alt={''} /></Link>
                                            <Link to={"#"} className={'w-52'}><img src={app02} alt={''} /></Link>
                                        </div>
                                    </div>
                                </div>
                                <div className={'flex justify-end absolute right-20 -top-24 sm-max:!top-20 md-max:!top-14 xl-max:top-7  xl-max:right-6'}>
                                    <AnimatedComponent
                                        tag="img"
                                        variants={popOut}
                                        src={iphoneslider}
                                        alt=""
                                        className={'rounded-[5px] xl:w-60p xl-max:w-47p md-max:!w-35p sm-max:w-!30p'}
                                    />

                                </div>
                            </div>



                        </div>
                    </AnimatedComponent>
                </div>
            </section>

            {/* REVENUE Section */}

            <div className={'w-full py-20 xl-max:pt-0 xl-max:pb-6 3xl:px-32 2xl:px-32 lg:px-16 px-6'}>
                <div className={'items-start  h-full grid grid-cols-1 3xl:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2   gap-16 xl-max:!gap-0'}>
                    <div className={'xl-max:order-last xl-max:mt-8'}>
                        <AnimatedComponent
                            tag="img"
                            variants={popOut}
                            src={YE2ARQM}
                            alt=""
                            className={'rounded-[5px] w-full'}
                        />
                    </div>
                    <div className={''}>
                        <AnimatedComponent
                            tag="div"
                            variants={stagger("negative")}
                            className={'leading-loose lg:text-left'}>
                            {/* <span className="small-head uppercase">Revenue</span> */}
                            <AnimatedComponent tag="div" variants={fadeInY(0.8)} className={''}>
                                <h2 className="Heading-02  my-2 mb-5"> {t("main.Data_optimize.Main_head")}
                                    <strong> {t("main.Data_optimize.strong_head")} </strong> </h2>


                                <p className={'paragraph'}>
                                    {t("main.Data_optimize.paragraph")}
                                </p>


                            </AnimatedComponent>
                        </AnimatedComponent>
                    </div>



                </div>
            </div>

            {/* Discover Section */}

            <div className={'w-full  3xl:px-32 2xl:px-32 lg:px-16 px-6 elementor-motion-effects-layer2'}>
                <div className={'items-start  h-full grid grid-cols-1 3xl:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 xl-max:gap-6  gap-16'}>


                    <div className={''}>
                        <AnimatedComponent
                            tag="div"
                            variants={stagger("negative")}
                            className={'leading-loose text-left'}>

                            <AnimatedComponent tag="div" variants={fadeInY(0.8)} className={''}>
                                <h5 className={'misium-head'}>{t("main.discover.Main_head")}</h5>


                                <div className={'w-full mt-8'}>
                                    {/* Block 01 */}
                                    <div className={'blocks mt-3'}>
                                        <ul className={'elementor-icon-list-items flex  items-start gap-3'}>

                                            <li className={'flex !font-semibold !text-[#75a743] !text-[22px] items-center mt-2'}>
                                                <span className={'mr-2 font-bold border-[2px] border-[#d3be48] rounded-full  w-[65px] h-[65px] flex justify-center items-center'}>
                                                    <img src={security} alt={'icon'} className={'w-10 '} />
                                                </span>
                                                {/* <FaMoneyBillTransfer className='mr-2 font-bold border-[2px] border-[#75a743] rounded-full p-2 w-12 h-12' /> */}

                                            </li>
                                            <span>
                                                <h3 className={'elementor-icon-list-text text-[#75a743]'}>
                                                    {t("main.discover.Security")}</h3>
                                                <p className={'paragraph'}>
                                                    {t("main.discover.security_para")}
                                                </p>
                                            </span>
                                            {/* <li className="flex !font-semibold !text-[#75a743] !text-[22px] items-center">

                                                <MdArrowForwardIos className='mr-2 font-bold' />
                                                <span className="elementor-icon-list-text  !font-semibold !text-[22px]">Security</span>
                                            </li> */}
                                        </ul>

                                    </div>

                                    {/* Block 02 */}
                                    <div className={'blocks mt-3'}>
                                        <ul className={'elementor-icon-list-items flex  items-start gap-3'}>
                                            <li className={'flex !font-semibold !text-[#75a743] !text-[22px] items-center mt-2'}>
                                                <span className={'mr-2 font-bold border-[2px] border-[#d3be48] rounded-full  w-[65px] h-[65px] flex justify-center items-center'}>
                                                    <img src={customer} alt='icon' className={'w-10 '} />
                                                </span>
                                                {/* <FaMoneyBillTransfer className='mr-2 font-bold border-[2px] border-[#75a743] rounded-full p-2 w-12 h-12' /> */}

                                            </li>
                                            <span>
                                                <h3 className={'elementor-icon-list-text text-[#75a743]'}>
                                                    {t("main.discover.Customer trust")}</h3>
                                                <p className={'paragraph'}>
                                                    {t("main.discover.customer_para")}
                                                </p>
                                            </span>

                                        </ul>

                                    </div>

                                    {/* Block 03 */}
                                    <div className={'blocks mt-3'}>
                                        <ul className={'elementor-icon-list-items flex  items-start gap-3'}>
                                            <li className={'flex !font-semibold !text-[#75a743] !text-[22px] items-center mt-2'}>
                                                <span className={'mr-2 font-bold border-[2px] border-[#d3be48] rounded-full  w-[65px] h-[65px] flex justify-center items-center'}>
                                                    <img src={pay} alt='icon' className={'w-10 '} />
                                                </span>
                                                {/* <FaMoneyBillTransfer className='mr-2 font-bold border-[2px] border-[#75a743] rounded-full p-2 w-12 h-12' /> */}

                                            </li>
                                            <span>
                                                <h3 className={'elementor-icon-list-text text-[#75a743]'}>
                                                    {t("main.discover.Multiple_payment_options")}
                                                </h3>
                                                <p className={'paragraph'}>
                                                    {t("main.discover.option_para")}
                                                </p>
                                            </span>

                                        </ul>

                                    </div>

                                </div>

                            </AnimatedComponent>
                        </AnimatedComponent>
                    </div>

                    <div className={''}>
                        <AnimatedComponent
                            tag="img"
                            variants={popOut}
                            src={HEC7BTZ}
                            alt={''}
                            className={'rounded-sm mb-6 w-full'}
                        />

                    </div>

                </div>
            </div>

            {/* Testimonials Section */}

            <div className={'w-full py-20xl-max:pt-0 xl-max:pb-6 3xl:px-32 2xl:px-32 lg:px-16 px-6 bg-[#fafafa]'}>
                <div className={'items-start  h-full grid grid-cols-1 3xl:grid-cols-2 2xl:grid-cols-2  xl:grid-cols-2 gap-28 xl-max:gap-0 text-left'}>

                    <div className={'text-left'}>
                        <AnimatedComponent
                            tag="div"
                            variants={stagger("negative")}
                            className={'leading-loose'}>
                            {/* <span className="small-head uppercase">Testimonials</span> */}
                            <AnimatedComponent tag="div" variants={fadeInY(0.8)} className="">
                                <h2 className="Heading-02 lg:text-[35px]  w-full  my-2 mb-3">
                                    {t("main.Client_area.Main_head")} <strong> {t("main.Client_area.strong_head")} </strong></h2>

                                <p className={'paragraph'}>
                                    {t("main.Client_area.paragraph")}
                                </p>

                                <div className={'mt-3 xl-max:mt-6'}>
                                    <AnimatedComponent
                                        tag="img"
                                        variants={popOut}
                                        src={T52GYVU}
                                        alt={''}
                                        className={'rounded-[5px] w-full'}
                                    />
                                </div>
                                {/* Button Area */}
                                {/* <div className="b mt-4 relative h-12 w-40 flex justify-center items-center ">
                  <div className="i h-12 w-40 bg-gradient-to-br from-[#fe7b05] to-[#eabb76] items-center rounded-sm shadow-2xl cursor-pointer absolute overflow-hidden transform hover:scale-x-110 hover:scale-y-105 transition duration-300 ease-out">
                  </div>
                  <Link className="text-center text-white font-medium flex items-center z-10 pointer-events-none">Apply Now <IoIosArrowForward className='ml-2' /></Link>


                </div> */}
                            </AnimatedComponent>
                        </AnimatedComponent>
                    </div>
                    <div className={'lg-max:order-last'}>
                        <div className={'p-8   mt-4 mb-10 text-left w-full bg-white  rounded-xl duration-500 shadow-xl'}>
                            <div className={'py-3 w-full text-left flex justify-between items-center'}>
                                <div className={'w-70p'}>
                                    <h6 className={'fearure-head'}>{t("main.Client_area.testimonial_head")}</h6>
                                </div>

                                <div className={'elementor-icon'}>
                                    <FaQuoteRight className={'w-10 h-10 text-[#75a743]'} />
                                </div>
                            </div>
                            <p className={'feature-para !mt-2'}>
                                {t("main.Client_area.testimonial_detail")}
                            </p>
                            <div className={'flex justify-between items-center lg-max:inline-block'}>
                                <div className={'flex items-top gap-5 mt-7'}>
                                    <img className={'w-14 h-14 rounded-md'} src={avtar01} alt='avtar' />
                                    <span className="">
                                        <h4 className={'text-[18px] font-semibold text-[#0b1622]'}>{t("main.Client_area.client_name")}</h4>
                                        <p className={'text-[13px] font-normal text-[#75a743]'}>
                                            {t("main.Client_area.client_detail")}</p>
                                    </span>
                                </div>
                                <ul className={'flex items-center gap-1 text-yellow-500 text-[18px] lg-max:pl-[73px] '}>
                                    <li><FaStar /></li>
                                    <li><FaStar /></li>
                                    <li><FaStar /></li>
                                    <li><FaStar /></li>
                                    <li><FaStar /></li>
                                </ul>
                            </div>
                        </div>

                        <div className={'p-8 mt-4 text-left w-full bg-white  rounded-xl duration-500 shadow-xl'}>
                            <div className={'py-3 w-full text-left flex justify-between items-center'}>
                                <div className={'w-70p'}>
                                    <h6 className={'fearure-head'}>{t("main.Client_area.testimonial_head_two")}</h6>
                                </div>

                                <div className={'elementor-icon'}>
                                    <FaQuoteRight className={'w-10 h-10 text-[#75a743]'} />
                                </div>
                            </div>
                            <p className={'feature-para !mt-2'}>{t("main.Client_area.testimonial_detail_two")}</p>
                            <div className={'flex justify-between items-center lg-max:inline-block'}>
                                <div className={'flex items-top gap-5 mt-7'}>
                                    <img className={'w-14 h-14 rounded-md'} src={avtar02} alt='avtar' />
                                    <span className="{}">
                                        <h4 className={'text-[18px] font-semibold text-[#0b1622]'}>
                                            {t("main.Client_area.client_name_two")}</h4>
                                        <p className={'text-[13px] font-normal text-[#75a743]'}>
                                            {t("main.Client_area.client_detail")}</p>
                                    </span>
                                </div>
                                <ul className={'flex items-center gap-1 text-yellow-500 text-[18px] lg-max:pl-[73px] '}>
                                    <li><FaStar /></li>
                                    <li><FaStar /></li>
                                    <li><FaStar /></li>
                                    <li><FaStar /></li>
                                    <li><FaStar /></li>
                                </ul>
                            </div>
                        </div>
                    </div>



                </div>
            </div>

            {/* Blog Section */}

            <div className={'w-full  py-20 xl-max:pt-0 xl-max:pb-6 3xl:px-32 2xl:px-32 lg:px-16 px-6'}>
                <AnimatedComponent
                    tag="div"
                    variants={stagger("negative")}
                    className={'leading-loose'}>
                    {/* <span className="small-head uppercase">Blog</span> */}
                    <AnimatedComponent tag="div" variants={fadeInY(0.8)} className="">
                        <h2 className="Heading-02 mb-6">{t("main.Blog.Main_head")} <strong>
                            {t("main.Blog.strong_head")}</strong> </h2>
                        <p className={'paragraph m-auto lg:max-w-2xl md:max-w-xl'}>
                            {t("main.Blog.paragraph")}
                        </p>

                    </AnimatedComponent>
                </AnimatedComponent>
                <AnimatedComponent tag="div" variants={fadeInY(0.8)} className="">
                    <div className={'grid grid-cols-1 lg:grid-cols-3 gap-6 mt-14'}>
                        <div className={'text-left w-full bg-white  rounded-xl  transition-all ease-in-out duration-500 hover:-translate-y-4 shadow-2xl hover:shadow-gray-800'}>
                            {/* <!-- Blog 1 --> */}
                            <div className={'text-left'}>
                                <img src={blog01} className={'mb-4'} alt='Blog img-1' />
                                <span className={'pt-2 pb-4 px-5 inline-block'}>
                                    <h2 className="mb-2">
                                        <Link href="#" className={'text-[24px] text-[#0b1622] font-semibold'}>
                                            {t("main.Blog.blog")}</Link>
                                    </h2>

                                    <div className={'flex space-x-1 text-[15px] text-[#0b1622]'}>
                                        <p> {t("main.Blog.blog_detail")}</p>
                                        {/* <span>·</span>
                                        <span>6 min read</span> */}
                                    </div>
                                </span>


                            </div>
                        </div>

                        <div className={'text-left w-full bg-white  rounded-xl  transition-all ease-in-out duration-500 hover:-translate-y-4 shadow-2xl hover:shadow-gray-800'}>
                            {/* <!-- Blog 2 --> */}
                            <div className={'text-left'}>
                                <img src={blog02} className={'mb-4'} alt='Blog img-1' />
                                <span className={'pt-2 pb-4 px-5 inline-block'}>
                                    <h2 className="mb-2">
                                        <Link href="#" className={'text-[24px] text-[#0b1622] font-semibold'}>
                                            {t("main.Blog.blog_one")}</Link>
                                    </h2>

                                    <div className={'flex space-x-1 text-[15px] text-[#0b1622]'}>
                                        <p> {t("main.Blog.blog_detail")}</p>
                                        {/* <p>Mar 20, 2024</p>
                                        <span>·</span>
                                        <span>2 min read</span> */}
                                    </div>
                                </span>
                            </div>
                        </div>

                        <div className={'text-left w-full bg-white  rounded-xl transition-all ease-in-out duration-500 hover:-translate-y-4 shadow-2xl hover:shadow-gray-800'}>
                            {/* <!-- Blog 3 --> */}
                            <div className={'text-left'}>
                                <img src={blog03} className={'mb-4'} alt='Blog img-1' />
                                <span className={'pt-2 pb-4 px-5 inline-block'}>
                                    <h2 className="mb-2">
                                        <Link href="#" className={'text-[24px] text-[#0b1622] font-semibold'}>
                                            {t("main.Blog.blog_two")}
                                        </Link>
                                    </h2>

                                    <div className={'flex space-x-1 text-[15px] text-[#0b1622]'}>
                                        <p> {t("main.Blog.blog_detail")}</p>
                                        {/* <p>Mar 20, 2024</p>
                                        <span>·</span>
                                        <span>2 min read</span> */}
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                </AnimatedComponent>
            </div>

        </div >
    );
}

export default Home;
